// extracted by mini-css-extract-plugin
module.exports = {"banner":"dmbc-banner","item":"dmbc-banner-item","image":"dmbc-banner-image","indicatorLeft":"dmbc-banner-indicatorLeft","indicatorRight":"dmbc-banner-indicatorRight"};